export type {
  RoadmapItem,
  RoadmapItemType,
  RoadmapModule,
  RoadmapItemData,
  RoadmapAssignmentData,
  RoadmapLessonData,
  RoadmapSelfCheckData,
} from '@cip/core/roadmap';

export {
  ALL_ROADMAP_ITEM_TYPES,
  RoadmapItemTypeSchema,
  RoadmapItemSchema,
  RoadmapModuleSchema,
} from '@cip/core/roadmap';

export const ROADMAP = {
  COMPLETION_LINK: {
    key: 'Self Check',
    title: 'Self Check Link',
  },
  ASSIGNMENT: {
    key: 'Assignment',
    title: 'Assignment',
  },
  MATH_ASSIGNMENT: {
    key: 'Math Assignment',
    title: 'Math Assignment',
  },
  LESSON: {
    key: 'Lesson',
    title: 'Lesson',
  },
  SECTION: {
    key: 'Section',
    title: 'Section',
  },
  SECTION_SHADOW: {
    key: 'Section Shadow',
    title: 'Section Shadow',
  },
  SECTION_DEBRIEF: {
    key: 'Section Debrief',
    title: 'Section Debrief',
  },
  SECTION_FEEDBACK: {
    key: 'Section Feedback',
    title: 'Section Feedback',
  },
  CREATE_ASSIGNMENT: {
    key: 'Create Assignment',
    title: 'Create Assignment',
  },
  UNTIED_LINK: {
    key: 'Link',
    title: 'Link',
  },
  AUTO_CHECK: {
    key: 'auto-check',
    title: 'Automatic Green Check',
  },
  ONE_OF: {
    key: 'One of',
    title: 'One of several Math Assignments',
  },
};

export const ROADMAP_CHOICES = Object.values(ROADMAP);
export const assnTypes = ['Karel', 'Console', 'Graphics'];
